import { render, staticRenderFns } from "./LobbyArea.vue?vue&type=template&id=97ce6ce6&"
import script from "./LobbyArea.vue?vue&type=script&lang=js&"
export * from "./LobbyArea.vue?vue&type=script&lang=js&"
import style0 from "./LobbyArea.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports